var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27294",
    "data-name": "Group 27294",
    transform: "translate(-305 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26029",
    "data-name": "Group 26029",
    transform: "translate(589.921 -175.7) rotate(135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26028",
    "data-name": "Group 26028",
    transform: "translate(314.415 30.624)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    x2: 24,
    transform: "translate(11.999 0) rotate(90)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    x2: 24,
    transform: "translate(0 12)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2903",
    "data-name": "Rectangle 2903",
    width: 48,
    height: 48,
    transform: "translate(305 1)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideClose);
export default __webpack_public_path__ + "static/media/guide-close.60be54cf35d66fd58e0cb69a20f2daac.svg";
export { ForwardRef as ReactComponent };